<template>
	<div>
		<div class="inbox">
			<bsf-page-header>
				<h3 slot="header">图表/charts </h3>
			</bsf-page-header>
			<breadcrumb :data="$store.state.bcArray"></breadcrumb>
		</div>
		<div class="container-fluid">
			<bsf-layout>
				<bsf-col size="xs" col="6">
					<bsf-panel>
						<h5 class="panel-title" slot="title">图表 Echart line</h5>
						<p></p>
						<template slot="body">
							<bsf-chart cheight="400" :data="chartData" ctitle="数据统计信息折线图" ctype="line"></bsf-chart>
						</template>
					</bsf-panel>
				</bsf-col>
				<bsf-col size="xs" col="6">
					<bsf-panel>
						<h5 class="panel-title" slot="title">图表 Echart line区域图</h5>
						<p></p>
						<template slot="body">
							<bsf-chart cheight="400" :data="chartData1" ctitle="数据统计信息面积图" ctype="line" :areaStyle="true"></bsf-chart>
						</template>
					</bsf-panel>
				</bsf-col>
				<bsf-col size="xs" col="6">
					<bsf-panel>
						<h5 class="panel-title" slot="title">图表 Echart 柱状图</h5>
						<p></p>
						<template slot="body">
							<bsf-chart cheight="400" :data="chartData2" ctitle="数据统计信息柱状图" ctype="bar"></bsf-chart>
						</template>
					</bsf-panel>
				</bsf-col>
				<bsf-col size="xs" col="6">
					<bsf-panel>
						<h5 class="panel-title" slot="title">图表 Echart 饼状图</h5>
						<p></p>
						<template slot="body">
							<bsf-chart cheight="400" :data="chartData3" ctitle="数据统计信息饼状图" ctype="pie"></bsf-chart>
						</template>
					</bsf-panel>
				</bsf-col>
			</bsf-layout>
		</div>
	</div>
</template>
<script>
	import bsfLayout from "components/css/layout"
	import bsfCol from "components/css/col"
	//
	import bsfPanel from 'components/comp/panel'
	import bsfPageHeader from 'components/comp/pageheader'
	import breadcrumb from 'components/comp/breadcrumbs'
	import bsfChart from 'components/comp/chart'
	//
	export default {
		components: {
			bsfLayout,
			bsfCol,
			//
			bsfPageHeader,
			breadcrumb,
			bsfPanel,
			bsfChart
		},
		data() {
			return {
				navdata1: [{
					name: "Home",
					href: ""
				}, {
					name: "Profile",
					href: ""
				}, {
					name: "Message",
					href: "",
					active: true
				}],
				chartData: [{
					type:'line',
					name: '邮件营销',
					stack: '总量',
					data: [120, 132, 101, 134, 90, 230, 210]
				}],
				chartData1: [{
					name: '联盟广告',
					stack: '总量',
					data: [220, 182, 191, 234, 290, 330, 310]
				}],
				chartData2: [{
					name: '视频广告',
					stack: '总量',
					data: [150, 232, 201, 154, 190, 330, 410,]
				}],
				chartData3: [{
					type: 'pie',
					data: [{
						value: 335,
						name: '直接访问'
					}, {
						value: 310,
						name: '邮件营销'
					}, {
						value: 234,
						name: '联盟广告'
					}, {
						value: 135,
						name: '视频广告'
					}, {
						value: 1548,
						name: '搜索引擎'
					}],
				}]
			}
		}
	}
</script>
<style lang="less">
	@import (reference) "../assets/lib/css.less";
	.inbox {
		.bdrb;
		.mgb;
		background-color: @cwh;
		.pd(@mpb 2*@mpb);
		.page-header {
			.mgb(@mpb/3);
		}
		.breadcrumb {
			.mgb(0)
		}
	}
</style>


// WEBPACK FOOTER //
// chart.vue?77a59548